import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, BookOpen, Heart, Shield } from 'lucide-react';
export function ProductDetails() {
  const features = [{
    icon: <Shield className="w-6 h-6 text-burgundy-600" data-id="element-155" />,
    title: 'El pacto de 3 reglas',
    desc: 'Para que nadie se sienta presionado/a ni obligado.'
  }, {
    icon: <div className="flex gap-1" data-id="element-156">
          <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-157" />
          <div className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-158" />
          <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-159" />
        </div>,
    title: 'El Semáforo',
    desc: "La herramienta para avanzar sin vergüenza y saber el 'clima' exacto."
  }, {
    icon: <BookOpen className="w-6 h-6 text-burgundy-600" data-id="element-160" />,
    title: 'Plan noche por noche',
    desc: 'Guía paso a paso de 10–20 min para 7 días consecutivos.'
  }, {
    icon: <Heart className="w-6 h-6 text-burgundy-600" data-id="element-161" />,
    title: 'Frases listas para usar',
    desc: "Palabras exactas para iniciar sin sentir que das 'cringe'."
  }];
  return <section className="py-24 px-4 bg-cream-50" data-id="element-162">
      <div className="max-w-5xl mx-auto" data-id="element-163">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-164">
          <FadeIn data-id="element-165">
            <div className="relative" data-id="element-166">
              <div className="absolute inset-0 bg-gold-200 rounded-3xl transform rotate-3 scale-95 opacity-50" data-id="element-167"></div>
              <div className="relative bg-white p-8 rounded-3xl shadow-xl border border-cream-200" data-id="element-168">
                <h3 className="text-sm font-bold tracking-widest text-burgundy-500 uppercase mb-6" data-id="element-169">
                  Qué incluye la guía
                </h3>
                <h2 className="text-3xl font-serif text-burgundy-900 mb-8" data-id="element-170">
                  7 Noches Para Volver a Tocarnos (Sin Vergüenza)
                </h2>
                <div className="space-y-6" data-id="element-171">
                  {features.map((feature, idx) => <div key={idx} className="flex gap-4" data-id="element-172">
                      <div className="flex-shrink-0 mt-1 w-10 h-10 rounded-full bg-cream-100 flex items-center justify-center" data-id="element-173">
                        {feature.icon}
                      </div>
                      <div data-id="element-174">
                        <h4 className="font-bold text-burgundy-900" data-id="element-175">
                          {feature.title}
                        </h4>
                        <p className="text-burgundy-700/80 text-sm" data-id="element-176">
                          {feature.desc}
                        </p>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </FadeIn>

          <div className="space-y-12" data-id="element-177">
            <FadeIn delay={200} data-id="element-178">
              <h3 className="text-2xl font-serif text-burgundy-900 mb-6" data-id="element-179">
                Para quién es (y para quién no)
              </h3>

              <div className="space-y-8" data-id="element-180">
                <div data-id="element-181">
                  <h4 className="flex items-center text-green-700 font-bold mb-3" data-id="element-182">
                    <Check className="w-5 h-5 mr-2" data-id="element-183" /> Es para ti si:
                  </h4>
                  <ul className="space-y-2 ml-7 text-burgundy-800" data-id="element-184">
                    <li className="list-disc" data-id="element-185">
                      Se quieren, pero se traban para iniciar
                    </li>
                    <li className="list-disc" data-id="element-186">
                      Te paraliza el miedo al rechazo
                    </li>
                    <li className="list-disc" data-id="element-187">
                      Quieren romance real, no actuación
                    </li>
                  </ul>
                </div>

                <div data-id="element-188">
                  <h4 className="flex items-center text-burgundy-900 font-bold mb-3 opacity-60" data-id="element-189">
                    <span className="mr-2 text-xl leading-none" data-id="element-190">×</span> No es
                    para ti si:
                  </h4>
                  <ul className="space-y-2 ml-7 text-burgundy-800/70" data-id="element-191">
                    <li className="list-disc" data-id="element-192">Buscas manipular o presionar</li>
                    <li className="list-disc" data-id="element-193">
                      Hay coerción o miedo en la relación
                    </li>
                  </ul>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={400} data-id="element-194">
              <div className="bg-white p-6 rounded-xl border-l-4 border-gold-400 shadow-sm" data-id="element-195">
                <p className="italic text-burgundy-800" data-id="element-196">
                  "No se siente como 'vamos a arreglar la relación'. Se siente
                  como: 'Por fin podemos acercarnos sin ponernos en riesgo'."
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}